module.exports = __webpack_public_path__ + "img/5.19309f35.png";